import { createSlice } from "@reduxjs/toolkit";
import { formatISO, addMonths, parseISO, subMonths } from "date-fns";

interface CalendarState {
  isoNow: string;
  selectedDates: string[];
}

const initialState: CalendarState = {
  isoNow: formatISO(new Date()),
  selectedDates: []
};

export const slice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    incrementMonth: (state): void => {
      state.isoNow = formatISO(addMonths(parseISO(state.isoNow), 1));
    },
    decrementMonth: (state): void => {
      state.isoNow = formatISO(subMonths(parseISO(state.isoNow), 1));
    },
    selectDate: (state, date: { payload: string }): void => {
      const index = state.selectedDates.indexOf(date.payload);
      if (index >= 0) {
        state.selectedDates.splice(index, 1);
      } else {
        state.selectedDates.push(date.payload);
      }
    }
  }
});

export const { incrementMonth, decrementMonth, selectDate } = slice.actions;

export default slice.reducer;
